import React from 'react';
import {Form} from '../../../components/form/Form';
import {useFormSubmit} from '../../../controllers/useSubmitForm';
import {CASCADER_NAVIGATE_TO_ADD_VIEW} from '../../common/constants/SourceConstants';
import {useAppStateContext} from '../../../providers/AppState';

export const KPIInputForm = props => {
  const {
    route: {params},
  } = props;
  const {row} = params;
  const {onSubmit} = useFormSubmit({
    uri: '/keyperformanceindicators',
    eventSourceId: 'keyperformanceindicators',
    ...props,
  });
  const {user} = useAppStateContext();

  return (
    <Form
      api={`/keyperformanceindicators/${row?._id}`}
      fields={{
        kra_id: {name: 1},
        name: 1,
        description: 1,
        api: {name: 1},
        entity: {label: 1},
        role: 1,
        index: 1,
        type: 1,
        owner: {name: 1},
        parent_kpi: {name: 1},
      }}
      onSubmit={onSubmit}
      header={{title: 'Add Key Performance Indicator'}}
      layoutFields={[
        {
          label: 'KRA',
          field: 'kra_id',
          type: 'autoComplete',
          api: `/keyresponsibilityareas`,
          suggestionField: 'name',
          valueField: 'name',
          displayField: 'name',
          size: 'medium',
          required: true,
        },
        {
          label: 'Name',
          type: 'text',
          field: 'name',
          required: true,
        },
        {
          label: 'Description',
          type: 'text',
          field: 'description',
          required: true,
        },
        // {
        //   label: 'Entity',
        //   field: 'entity',
        //   type: 'autoComplete',
        //   api: `/types`,
        //   suggestionField: 'label',
        //   size: 'medium',
        // },
        // {
        //   label: 'Role',
        //   field: 'role',
        //   type: 'autoComplete',
        //   api: '/role/modifiedData',
        //   suggestionField: 'role',
        //   valueField: 'role',
        // },
        {
          label: 'API',
          field: 'api',
          type: 'autoComplete',
          api: `/apis`,
          suggestionField: 'name',
          valueField: 'name',
          displayField: 'name',
          size: 'medium',
          required: true,
        },
        {
          label: 'Parent Kpi',
          field: 'parent_kpi',
          type: 'autoComplete',
          api: '/keyperformanceindicators',
          suggestionField: 'name',
          valueField: 'name',
          displayField: 'name',
          size: 12,
        },
        {
          field: 'type',
          label: 'Type',
          type: 'text',
          visible: () => {
            if (
              user.email === 'sushil.nagvan@daffodilsw.com' ||
              user.email === 'amit.singh@daffodildb.com'
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
        {
          field: 'index',
          label: 'Index',
          type: 'number',
          visible: () => {
            if (
              user.email === 'sushil.nagvan@daffodilsw.com' ||
              user.email === 'amit.singh@daffodildb.com'
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
        {
          label: 'Owners',
          field: 'owner',
          type: 'multiAutoComplete',
          api: `/employeeSuggestions`,
          suggestionField: 'name',
          secondarySuggestionField: 'official_email_id',
          valueField: 'name',
        },
      ]}
      {...props}
    />
  );
};

export const EditKPIInputForm = props => {
  return (
    <KPIInputForm
      header={{title: 'Edit Key Performance Indicator'}}
      mode="edit"
      {...props}
    />
  );
};
